<template>
  <div class="questionBackground">
    <div class="questionBlock">
      <div class="sideMenu">
        <div class="colorBackground">
          <div class="listWrap">
            <div
              class="list"
              v-for="data in sideTabs"
              :key="data.label"
              @click="switchQA(data.label)"
            >
              <div class="iconBg"><component :is="data.icon"></component></div>
              {{ data.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="panelBlock">
        <h1>{{ qaTitle }}</h1>
        <div class="qaBox" v-for="(data, index) in qaData" :key="index">
          <div
            :class="['question', { active: data.toggle }]"
            @click="data.toggle = !data.toggle"
          >
            <span>{{ data.question }}</span>
            <RiArrowDownSLine v-if="data.toggle" />
            <RiArrowUpSLine v-else />
          </div>
          <div
            :class="['answer', { active: data.toggle }]"
            v-html="data.answer"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, shallowRef, computed } from 'vue';
import {
  RiHome2Line,
  RiChat1Line,
  RiCloudyLine,
  RiQuillPenLine,
  RiArrowDownSLine,
  RiArrowUpSLine,
} from 'vue-remix-icons';
import { useI18n } from 'vue-i18n';
const { tm, t } = useI18n();
const qaTitle = computed(() => {
  return t('FAQ.general');
});
const sideTabs = shallowRef([
  {
    label: t('FAQ.general'),
    icon: RiHome2Line,
  },
  // {
  //   label: 'Tech',
  //   icon: RiChat1Line,
  // },
  // {
  //   label: 'Transaction',
  //   icon: RiCloudyLine,
  // },
  // {
  //   label: 'Fees',
  //   icon: RiQuillPenLine,
  // },
]);
const qaData = computed(() => {
  return tm('FAQ.qaData');
});

const switchQA = (label) => {
  qaTitle.value = label;
};
</script>

<style lang="less">
.questionBackground {
  padding: 3rem 0;
  width: 100%;
  background: #ecf1f9;
  .questionBlock {
    max-width: 120rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 3fr;
    .sideMenu {
      min-width: 20rem;
      margin: 3rem 2rem;
      .colorBackground {
        border-radius: 1rem;
        background: #fff;
        padding: 1rem;
        .listWrap {
          padding: 1rem 2rem;
          background: #183b56;
          border-radius: 1rem;
          font-size: 1.7rem;
          color: #fff;
          .list {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 2rem 0;
            cursor: pointer;
            .iconBg {
              width: 4rem;
              height: 4rem;
              background: rgba(255, 255, 255, 0.247);
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 1rem;
              .remixicon {
                width: 2rem;
                height: 2rem;
                fill: #fff;
              }
            }
          }
        }
      }
    }
    .panelBlock {
      width: 100%;
      h1 {
        font-size: 5rem;
        text-align: left;
      }
      .qaBox {
        width: 100%;
        background: #fff;
        border-radius: 1rem;
        padding: 0 2rem;
        font-size: 2rem;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 3rem 0;
        .question {
          width: 100%;
          display: flex;
          justify-content: space-between;
          transition: 0.3s;
          padding: 3rem 0;
          cursor: pointer;
          .remixicon {
            width: 2rem;
            height: 2rem;
          }
        }
        .question.active {
          border-bottom: 1px solid rgb(207, 207, 207);
        }
        .answer {
          opacity: 0;
          height: 0;
          transition: 0.3s;
          text-align: left;
        }
        .answer.active {
          white-space: pre-wrap;
          font-weight: 400;
          margin-top: 3rem;
          padding-bottom: 3rem;
          opacity: 1;
          height: auto;
        }
      }
    }
  }
}
</style>
